import { moneyValidator,isInt,isNumber } from "@/utils/validate";

export default {
    computed: {
        detailRule() {
            return {
                name:[{ required: true, message: "请填写品名", trigger: "change" }],
                code:[{ required: true, message: "请填写品番号", trigger: "change" }],
                count: [
                    { required: true, message: "请填写数量", trigger: "change" },
                    {
                        validator: function (rule, value, callback) {
                            if (!isNumber(value) ) {
                                callback(new Error("请输入正确的数量"));
                            }
                            callback();
                        },
                        trigger: "change",
                    },
                ],
                countB: [
                    {
                        validator: function (rule, value, callback) {
                            if(!value){
                                callback();
                            }
                            if (!isNumber(value) ) {
                                callback(new Error("请输入正确的数量"));
                            }else{
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
            }
        },
        dataRule() {
            return {
                agreementCode:[{
                    required: true,
                    message: this.$t("validate.required"),
                    trigger: "change",
                }],
                operateTime:[{
                    required: true,
                    message: this.$t("validate.required"),
                    trigger: "change",
                }],
                storageId:[{
                    required: true,
                    message: this.$t("validate.required"),
                    trigger: "change",
                }],
                // imgs:[{
                //     required: true,
                //     message: this.$t("validate.required"),
                //     trigger: "change",
                // }],
            };
        },
    }
}
